const translationsCs = {
    "FOOTER_RIGHT_TEXT"                 : "Tato stránka používá cookies"
};

export default translationsCs;
